import Sparkle from '@src/assets/svg/sparkle';

export default function ChatIntro() {
  return (
    <div
      className="
        absolute
        left-[116px]
        top-[104px]
        flex
        flex-col
        items-center
        justify-center
        gap-[20px]
        text-center
      "
    >
      {/* Title + Avatar Row */}
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <div className="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-[#006CFF] text-white shrink-0">
          <Sparkle />
        </div>

        {/* Title */}
        <h2 className="font-geist text-[24px] font-medium tracking-[-0.72px] text-[#171717]">
          Hi, I&apos;m{' '}
          <span className="leading-[28px]">
            <span
              className="
                bg-[linear-gradient(135deg,#B84DFF_0%,#006CFF_100%)]
                bg-clip-text
                text-transparent
              "
            >
              Ze
            </span>

            <span className="text-[#006CFF]">me!</span>
          </span>
        </h2>
      </div>

      {/* Subtitle */}
      <p
        className="
          max-w-xs
          font-geist
          text-[16px]
          font-medium
          leading-[30px]
          tracking-[-0.48px]
          text-[#171717]/50
        "
      >
        Just tell me what you&apos;re looking for,
        <br /> I&apos;ll handle the filters and map.
      </p>
    </div>
  );
}
